import { c as _c } from "react/compiler-runtime";
import { Badge } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { TransformedDocument } from '@/entity/hooks/use-documents';
type AiImageFlagBadgeProps = {
  uploads: TransformedDocument['uploads'];
};
const AiImageFlagBadge = t0 => {
  const $ = _c(5);
  const {
    uploads
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const isFlagged = uploads.some(_temp);
  if (!isFlagged) {
    return null;
  }
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp2);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Badge variant="warning">{t2}</Badge>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default AiImageFlagBadge;
function _temp(t0) {
  const {
    isLatest,
    experiment
  } = t0;
  const {
    openai,
    jev
  } = experiment?.aiImageScore ?? {};
  return isLatest && (openai?.verdict === "flag" || jev?.verdict === "flag");
}
function _temp2($) {
  return $.possibleFakeImage;
}